import React, { useState } from 'react';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import './PaiementsCoteIvoire.css';

// Icônes
import { 
    FaCreditCard, 
    FaCheckCircle, 
    FaTimesCircle,
    FaEuroSign,
    FaGraduationCap,
    FaCertificate,
    FaHeadset,
    FaFileAlt,
    FaLock,
    FaShieldAlt,
    FaQuestionCircle,
    FaInfoCircle,
    FaMapMarkerAlt,
    FaFlag,
    FaHeart,
    FaArrowRight
} from 'react-icons/fa';

const PaiementsCoteIvoire = () => {
    const [offreSelectionnee, setOffreSelectionnee] = useState(null);
    const [showModal, setShowModal] = useState(false);

    // Liens Stripe pour les paiements Côte d'Ivoire (prix corrigés)
    const liensPaiement = {
        etudeDossier: 'https://buy.stripe.com/14AaEX9yZ8hM54vfr73wQ07',
        standard: 'https://buy.stripe.com/eVq00jeTj7dI0OfbaR3wQ06',
        premium: 'https://buy.stripe.com/14A3cv3aBapUcwX3Ip3wQ05',
        nonDefinie: 'https://buy.stripe.com/28EcN5aD3cy2aoPgvb3wQ04'
    };

    // Offres disponibles pour la Côte d'Ivoire (prix corrigés)
    const offres = [
        {
            id: 'etudeDossier',
            nom: 'Étude de Dossier',
            prix: 155,
            devise: '€',
            lien: liensPaiement.etudeDossier,
            icon: FaFileAlt,
            description: 'Analyse complète de votre dossier académique',
            features: [
                'Analyse détaillée du dossier scolaire',
                'Évaluation des chances d\'admission',
                'Conseils personnalisés pour étudiants ivoiriens',
                'Feedback sur votre CV et lettres de motivation',
                'Recommandations d\'amélioration',
                'Délai de réponse : 72h'
            ]
        },
        {
            id: 'standard',
            nom: 'Offre Standard',
            prix: 155,
            devise: '€',
            lien: liensPaiement.standard,
            icon: FaGraduationCap,
            description: 'Accompagnement complet pour votre orientation en France',
            features: [
                'Tout de l\'offre Étude de Dossier',
                'Accompagnement personnalisé pour étudiants ivoiriens',
                'Aide à la rédaction de lettres de motivation',
                'Préparation aux entretiens Campus France',
                'Suivi hebdomadaire',
                'Accès aux webinaires exclusifs',
                'Assistance pour les démarches Campus France'
            ]
        },
        {
            id: 'premium',
            nom: 'Offre Premium',
            prix: 765,
            devise: '€',
            lien: liensPaiement.premium,
            icon: FaCertificate,
            description: 'Accompagnement VIP vers la réussite en France',
            features: [
                'Tout de l\'offre Standard',
                'Accompagnement illimité',
                'Simulations d\'entretiens Campus France',
                'Aide à la recherche de logement en France',
                'Assistance pour les démarches visa étudiant',
                'Support prioritaire 7j/7',
                'Coaching individuel personnalisé',
                'Garantie satisfaction',
                'Suivi après l\'arrivée en France'
            ],
            populaire: true
        },
        {
            id: 'nonDefinie',
            nom: 'Offre Personnalisée',
            prix: null,
            devise: '€',
            lien: liensPaiement.nonDefinie,
            icon: FaHeart,
            description: 'Vous pouvez librement choisir le montant de votre contribution',
            personnalisable: true,
            features: [
                'Soutenez notre mission éducative pour les étudiants ivoiriens',
                'Contribution à votre convenance',
                'Accompagnement adapté à vos besoins spécifiques',
                'Contact personnalisé avec notre équipe',
                'Suivi dédié selon votre investissement',
                'Possibilité de payer en plusieurs fois'
            ]
        }
    ];

    const handlePaiement = (offre) => {
        setOffreSelectionnee(offre);
        
        // Redirection directe vers Stripe
        window.open(offre.lien, '_blank');
        
        setShowModal(true);
    };

    const fermerModal = () => {
        setShowModal(false);
        setOffreSelectionnee(null);
    };

    return (
        <div className="paiements-ci-section">
            <Header />
            
            <div className="paiements-ci-container">
                {/* Bannière stylée Côte d'Ivoire */}
                <div className="paiements-ci-banner">
                    <div className="banner-pattern"></div>
                    
                    {/* Éléments décoratifs */}
                    <div className="banner-decoration">
                        <div className="deco-circle deco-circle-1"></div>
                        <div className="deco-circle deco-circle-2"></div>
                        <div className="deco-line deco-line-1"></div>
                        <div className="deco-line deco-line-2"></div>
                    </div>
                    
                    <div className="banner-content">
                        <div className="ci-flag-badge">
                            <FaFlag />
                            <span>Côte d'Ivoire</span>
                        </div>
                        <FaCreditCard className="banner-icon" />
                        <h1 className="banner-title">
                            Paiements <span>Côte d'Ivoire</span>
                        </h1>
                        <p className="banner-subtitle">
                            Offres spécialement conçues pour les étudiants ivoiriens souhaitant étudier en France
                        </p>
                        
                        {/* Badges de confiance */}
                        <div className="banner-trust">
                            <div className="trust-item">
                                <FaShieldAlt />
                                <span>Paiement 100% sécurisé</span>
                            </div>
                            <div className="trust-item">
                                <FaMapMarkerAlt />
                                <span>Spécial Côte d'Ivoire</span>
                            </div>
                            <div className="trust-item">
                                <FaHeadset />
                                <span>Support 7j/7</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Grille des offres */}
                <div className="offres-ci-grid">
                    {offres.map((offre) => (
                        <div 
                            key={offre.id} 
                            className={`offre-ci-card ${offre.populaire ? 'premium' : ''} ${offre.personnalisable ? 'personnalisable' : ''}`}
                        >
                            {offre.populaire && (
                                <span className="popular-ci-badge">
                                    <FaCheckCircle /> Recommandé
                                </span>
                            )}
                            
                            <div className="offre-ci-header">
                                <offre.icon className="offre-ci-icon" />
                                <h2>{offre.nom}</h2>
                                <div className="offre-ci-prix">
                                    {offre.prix ? (
                                        <>
                                            <span className="currency">{offre.devise}</span>
                                            {offre.prix.toLocaleString('fr-FR')}
                                        </>
                                    ) : (
                                        <span>Montant libre</span>
                                    )}
                                </div>
                            </div>
                            
                            <div className="offre-ci-body">
                                <p className="offre-ci-description">{offre.description}</p>
                                
                                <ul className="offre-ci-features">
                                    {offre.features.map((feature, index) => (
                                        <li key={index}>
                                            <FaCheckCircle className="feature-ci-icon" />
                                            {feature}
                                        </li>
                                    ))}
                                </ul>
                                
                                <button 
                                    className="btn-ci-payer"
                                    onClick={() => handlePaiement(offre)}
                                >
                                    <FaCreditCard />
                                    {offre.prix ? `Payer ${offre.prix.toLocaleString('fr-FR')} €` : 'Choisir mon montant sur Stripe'}
                                    <FaArrowRight />
                                </button>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Section d'information spécifique Côte d'Ivoire */}
                <div className="paiements-ci-info">
                    <h3 className="info-ci-title">
                        <FaInfoCircle />
                        Informations importantes - Côte d'Ivoire
                    </h3>
                    
                    <div className="info-ci-content">
                        <div className="info-ci-block">
                            <h4>
                                <FaShieldAlt />
                                Paiement sécurisé depuis la Côte d'Ivoire
                            </h4>
                            <p>
                                Tous les paiements sont traités de manière sécurisée via Stripe, 
                                accessible depuis la Côte d'Ivoire. Vos informations bancaires 
                                sont cryptées et jamais stockées sur nos serveurs. Paiement possible 
                                avec carte Visa, Mastercard, ou American Express.
                            </p>
                        </div>
                        
                        <div className="info-ci-block">
                            <h4>
                                <FaLock />
                                Accompagnement spécifique
                            </h4>
                            <p>
                                • Assistance pour les démarches Campus France Abidjan<br />
                                • Préparation aux entretiens avec l'espace Campus France<br />
                                • Aide à la constitution du dossier de demande de visa<br />
                                • Suivi personnalisé depuis la Côte d'Ivoire jusqu'à l'arrivée en France<br />
                                • Remboursement intégral si votre dossier n'est pas traité
                            </p>
                        </div>
                        
                        <div className="info-ci-block">
                            <h4>
                                <FaQuestionCircle />
                                Questions fréquentes - Côte d'Ivoire
                            </h4>
                            <ul>
                                <li>
                                    <FaCheckCircle />
                                    Puis-je payer en CFA ? Oui, la conversion est automatique
                                </li>
                                <li>
                                    <FaCheckCircle />
                                    Y a-t-il un représentant en Côte d'Ivoire ? Oui, contactez-nous
                                </li>
                                <li>
                                    <FaCheckCircle />
                                    Comment se passe l'accompagnement ? En visioconférence ou à Abidjan
                                </li>
                                <li>
                                    <FaCheckCircle />
                                    Puis-je payer en plusieurs fois ? Contactez notre équipe
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                {/* Section contact Côte d'Ivoire */}
                <div className="ci-contact-section">
                    <div className="ci-contact-card">
                        <div className="ci-contact-icon">
                            <FaHeadset />
                        </div>
                        <h3>Besoin d'aide pour votre paiement ?</h3>
                        <p>
                            Notre équipe dédiée aux étudiants ivoiriens est à votre disposition 
                            pour vous accompagner dans vos démarches.
                        </p>
                        <div className="ci-contact-buttons">
                            <a href="mailto:contact@etef.fr" className="ci-contact-btn email">
                                contact@etef.fr
                            </a>
                            <a href="tel:+2250758823639" className="ci-contact-btn phone">
                                +225 07 58 82 36 39
                            </a>
                        </div>
                        <p className="ci-contact-note">
                            <FaHeart /> Service disponible du lundi au samedi, 9h-18h (GMT)
                        </p>
                    </div>
                </div>
            </div>

            {/* Modal de confirmation */}
            {showModal && offreSelectionnee && (
                <div className="modal-ci-overlay" onClick={fermerModal}>
                    <div className="modal-ci-content" onClick={(e) => e.stopPropagation()}>
                        <button className="modal-ci-close" onClick={fermerModal}>
                            <FaTimesCircle />
                        </button>
                        
                        <div className="modal-ci-icon">
                            <FaCheckCircle />
                        </div>
                        
                        <h3>Paiement initié !</h3>
                        
                        <p>
                            Vous allez être redirigé vers la plateforme de paiement sécurisée Stripe.
                            {offreSelectionnee.prix === null && (
                                <><br /><strong>Pour l'offre personnalisée, vous pourrez choisir librement votre montant sur Stripe.</strong></>
                            )}
                        </p>
                        
                        <div className="modal-ci-details">
                            <p>
                                <strong>Offre :</strong> {offreSelectionnee.nom}<br />
                                <strong>Montant :</strong> {offreSelectionnee.prix 
                                    ? `${offreSelectionnee.prix.toLocaleString('fr-FR')} €` 
                                    : 'À définir sur Stripe'}
                            </p>
                            <p className="ci-note">
                                <FaMapMarkerAlt /> Offre spéciale Côte d'Ivoire
                            </p>
                        </div>
                        
                        <button className="modal-ci-btn" onClick={fermerModal}>
                            J'ai compris
                        </button>
                    </div>
                </div>
            )}

            <Footer />
        </div>
    );
};

export default PaiementsCoteIvoire;